import TodoApp from "./components/todoapp";

function App() {
  return (
   <TodoApp></TodoApp>
  );
}

export default App;
